import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { TranslationService, User } from '@spartacus/core';
import { UserAccountFacade } from "@spartacus/user/account/root";
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { prettifyTextForUrl } from "src/app/custom/util/filter-text";
import { ICON_TYPE } from "../../../icons/icon.model";
import { CustomFamiliesService } from './services/custom-families.service';
import { getAllFamiliesListState } from './store/selectors/custom-families.selectors';

@Component({
  selector: 'app-custom-families',
  templateUrl: './custom-families.component.html',
  styleUrls: ['./custom-families.component.scss'],
  standalone: false
})
export class CustomFamiliesComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  families$: Observable<any[]>;
  private professional = false;
  private user$: Observable<User | undefined> = this.userAccount.get();
  code: string;
  iconTypes = ICON_TYPE;
  isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(
    protected familiesService: CustomFamiliesService,
    private store: Store,
    protected route: ActivatedRoute,
    protected userAccount: UserAccountFacade,
    protected translation: TranslationService,
    private titleService: Title,
  ) {
    // empty
  }

  ngOnInit(): void {
    this.families$ = this.store.pipe(select(getAllFamiliesListState));

    const tasks$: Observable<[User, ParamMap]> = combineLatest([this.user$, this.route.paramMap]);

    this.subscriptions.add(tasks$.subscribe(([user, urlParams]: [User, ParamMap]) => {
          this.professional = user?.professional || false;
          this.code = urlParams?.get('familyCode');
          this.loadFamilies();
        }
      )
    );

    this.loadFamilies();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.isLoading$.next(false);
  }

  private loadFamilies(): void {
    this.familiesService.loadFamilies(this.code, this.professional);
    setTimeout(() => {
      this.isLoading$.next(true);
    }, 1000);
  }

  get btnClass(): string {
    return 'btn btn-block btn-white btn-sm';
  }

  setTitleNotFoundPage() {
    this.subscriptions.add(
      this.translation.translate('common.notFound').subscribe({
        next: (title) => this.titleService.setTitle(title),
      })
    );
  }

  sanitizedCategory(param: string): string {
    return prettifyTextForUrl(param);
  }
}
